import { Action } from '@ngrx/store';
import { TokenResponseModel } from '../../models';
import { UserOrganizations } from '../../models/UserOrganizations';

/* ************************* CONFIG FOR LOGGED USER ************************* */
export enum ELoggedUserStoreActions {
    SAVE_LOGGED_USER = '[LOGGED_USER] SAVE',
    CLEAR_LOGGED_USER = '[LOGGED_USER] CLEAR'
}

export class SaveLoggedUserAction implements Action {
    readonly type: string = ELoggedUserStoreActions.SAVE_LOGGED_USER;

    constructor(public payload: TokenResponseModel) { }
}

export class ClearLoggedUserAction implements Action {
    readonly type: string = ELoggedUserStoreActions.CLEAR_LOGGED_USER;
    constructor(public payload: string = null) { }
}

export type TokenActions = SaveLoggedUserAction | ClearLoggedUserAction;
/* ************************* END CONFIG FOR LOGGED USER ************************* */

/** ************************ CONFIG FOR USER ROLES ************************* */
export enum EUserRolesStoreActions {
    SAVE_USER_ROLES = '[USER_ROLES] SAVE',
    CLEAR_USER_ROLES = '[USER_ROLES] CLEAR'
}

export class SaveUserRolesAction implements Action {
    readonly type = EUserRolesStoreActions.SAVE_USER_ROLES;
    constructor(public payload: string[]) { }
}

export class ClearUserRolesAction implements Action {
    readonly type = EUserRolesStoreActions.CLEAR_USER_ROLES;
}

export type UserRolesActions = SaveUserRolesAction | ClearUserRolesAction;
/* ************************* END CONFIG FOR USER ROLES ************************* */

/** ************************ CONFIG FOR USER ORGANIZATIONS ************************* */
export enum EUserOrganizationsStoreActions {
    SAVE_USER_ORGANIZATIONS = '[USER_ORGANIZATIONS] SAVE',
    CLEAR_USER_ORGANIZATIONS = '[USER_ORGANIZATIONS] CLEAR'
}

export class SaveUserOrganizationsAction implements Action {
    readonly type = EUserOrganizationsStoreActions.SAVE_USER_ORGANIZATIONS;
    constructor(public payload: UserOrganizations[]) { }
}

export class ClearUserOrganizationsAction implements Action {
    readonly type = EUserOrganizationsStoreActions.CLEAR_USER_ORGANIZATIONS;
}

export type UserOrganizationsActions = SaveUserOrganizationsAction | ClearUserOrganizationsAction;
/* ************************* END CONFIG FOR USER ORGANIZATIONS ************************* */